import { z } from 'zod/v4';

import { ZOD_ERROR } from '../models/constants';
import { assetInviteResultSchema } from './asset-invite-result.schema';
import { BaseMessage, baseMessageSchema } from './base-message.schema';

const assetInviteCompletedSchema = z.object({
  Id: z.string(),
  Type: z.string(),
  Result: assetInviteResultSchema,
});

export const assetInviteCompletedEventSchema = baseMessageSchema.transform(
  (data) => {
    const message = JSON.parse(data.message) as BaseMessage;
    const { success, data: result } = assetInviteCompletedSchema
      .transform((d) => ({
        id: d.Id,
        type: d.Type,
        result: {
          errorCode: d.Result.ErrorCode,
          totalInvitesFailed: d.Result.TotalInvitesFailed,
          totalInvitesSent: d.Result.TotalInvitesSent,
        },
      }))
      .safeParse(message);

    if (success) {
      return result;
    }

    return {
      id: '',
      type: '',
      result: {
        errorCode: ZOD_ERROR,
        totalInvitesFailed: 0,
        totalInvitesSent: 0,
      },
    };
  }
);
